/** 库存管理API */
import type { Api } from '@/typings/api';
import { download, post, upload } from '../../request';
const prefix = '/inventory/inventoryInfo';
/**
 * 分页查询库存管理
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Inventory.InventoryInfo> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询库存管理列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Inventory.InventoryInfo> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个库存管理
 *
 * @param id 库存管理ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Inventory.InventoryInfo> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存库存管理
 *
 * @param params 库存管理信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新库存管理信息
 *
 * @param params 库存管理信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除库存管理
 *
 * @param id 库存管理ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除库存管理
 *
 * @param ids 库存管理ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/** 库存盘点 */
export const inventoryCount = (params: {
  inventoryInfo: Api.Inventory.InventoryInfo[];
  description: string;
  customerId?: string;
}) => {
  return post(`${prefix}/inventoryCount`, params);
};

/** 导入文件 */
export const importInventory = (params: File) => {
  return post(`${prefix}/importData`, params);
};

/** 导入线下采购库存 */
export const importOfflineInventory = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/importOfflineData`, file, params);
};
/**
 * 导入
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/import`, file, params);
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

// 报表导出
export const doReportExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params, '工厂库存报表.xlsx');
};

/**
 * 车膜库存导入（U8订单质保）
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const doInvImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/invImport`, file, params);
};

/**
 * 车膜库存导入（直接导入门店）
 *
 * @param file 文件
 * @param params
 * @returns
 */
export const directInvImport = (file: File, params: Api.Common.ImportParams = { isCustom: true }) => {
  return upload(`${prefix}/directInvImport`, file, params);
};

/**
 * 库存调拨
 * @param params
 * @returns
 */
export const allocatedInventory = (params: any) => {
  return post(`${prefix}/allocatedInventory`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  doImport,
  doExport
};
